module.exports = __webpack_public_path__ + "static/media/toilet_paper_getty_mobile.fc16f5df.jpg";